export var generateSharedCalendarId = function (calendarInfo) {
    if (!hasAllRequiredSharedCalendarValues(calendarInfo)) {
        return '';
    }
    var calendarInfoString = JSON.stringify(calendarInfo);
    var encodedValue = window.btoa(calendarInfoString); // JSON string to 64bit
    return encodedValue;
};
export var parseSharedCalendarId = function (calId) {
    if (!calId) {
        return null;
    }
    try {
        var decodedValue = window.atob(calId); // 64bit to JSON string
        var actualObj = JSON.parse(decodedValue) || {};
        // only valid if all values are found
        return hasAllRequiredSharedCalendarValues(actualObj) ? actualObj : null;
    }
    catch (_a) {
        return null;
    }
};
var hasAllRequiredSharedCalendarValues = function (objValue) {
    if (!objValue || typeof objValue !== 'object') {
        return false;
    }
    var teamAccountId = objValue.teamAccountId, teamName = objValue.teamName, officeId = objValue.officeId, officeAddress = objValue.officeAddress, timezone = objValue.timezone;
    return teamAccountId && teamName && officeId && officeAddress && timezone;
};
